<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
</script>

<!--
Just a layout component.
The intent for content and breadcrumb slots is to use one or the other.
One when we want the left content to fill in space, and the other when we don't.
-->
<template>
  <div
    :class="
      twMerge(
        'flex w-full shrink-0 basis-10 items-center justify-between px-3 text-sm-12px-default',
        typeof $attrs.class === 'string' ? $attrs.class : '',
      )
    "
  >
    <div
      v-if="$slots.content"
      class="flex max-w-full min-w-0 grow flex-row items-center gap-0"
    >
      <slot name="content" />
    </div>
    <!-- Breadcrumbs slot -->
    <div
      v-if="$slots.breadcrumbs"
      class="flex max-w-[70%] min-w-0 flex-row items-center gap-0"
    >
      <slot name="breadcrumbs" />
    </div>

    <!-- Actions slot -->
    <div class="flex shrink-0 flex-row items-center gap-0.5">
      <slot name="actions" />
    </div>
  </div>
</template>
